//
// Copyright (c) 2024 Comcast
//

import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import Badge from 'components/Shared/Badge/Index'

import colors from 'components/utils/colors'

const StyledSection = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${colors.secondary70};
  color: ${props => props.$value ? colors.secondary20 : colors.secondary40};
  font-size: 14px;
  line-height: 16px;
  padding: 12px 16px;
`

const PropTitle = styled.div`
  text-transform: uppercase;
`

// separate container ensures that badge is not cropped when title is wide
const BadgeContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: 2px;
`

const SidebarSectionBool = ({ title, value }) => {
  const { t } = useTranslation()
  const valueText = value ? t('common.on') : t('common.off')
  const badgeColor = value ? colors.success73 : colors.secondary90

  return (
    <StyledSection data-test='sidebar-section-bool' $value={value}>
      <PropTitle data-test='sidebar-section-bool-title'>{title}</PropTitle>
      <BadgeContainer>
        <Badge color={badgeColor} margin='0' data-test='sidebar-section-bool-value'>
          {valueText}
        </Badge>
      </BadgeContainer>
    </StyledSection>
  )
}

SidebarSectionBool.propTypes = {
  title: PropTypes.string,
  value: PropTypes.bool,
}

export default SidebarSectionBool
